module.exports = __webpack_public_path__ + "curalate-logo-o.a65e67b3416be0c8c880c71097109367.svg";